/* eslint-disable consistent-return */
/* eslint-disable no-console */
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import * as CareLabelConfigService from '../../../../services/careLabel.service';
import * as OrderPermissionService from '../../../../services/order-permission.service';
import type from './CARELABEL.type';

const somethingWentWrong = 'Something went wrong';

export const fetchProductDetails = (id) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getProductDetails(id);
    if (res?.code === 200) {
      await dispatch({ type: type.FETCH_PRODUCT_DETAILS, payload: res.data });
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const fetchOrderPermission = (payload) => async (dispatch) => {
  try {
    const res = await OrderPermissionService.getOrderPermission(payload);
    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_ORDER_PERMISSION_CARELABEL,
        payload: res.data,
      });
    }
    return true;
  } catch (error) {
    toasterMsg(somethingWentWrong, 'danger');
    return false;
  }
};

export const saveOrderPermission = (params, payload, val, transactionMsg) => async (dispatch) => {
  try {
    const res = await OrderPermissionService.saveOrderPermission(params, payload);
    if (res && res.code === 200 && val !== 'switch') {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.UPDATED_SUCCESSFULY'), 'success');
    }
    if (res && res.code === 200 && val === 'switch') {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_SAVED'), 'success');
      await dispatch({
        type: type.UPDATE_CARE_LABEL_SWITCHES,
        payload: payload.isVisibleToSupplier,
      });
    }
    return res?.code === 200;
  } catch (error) {
    toasterMsg(somethingWentWrong, 'danger');
    return false;
  }
};

export const fetchCareLabelProduct = (params) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getCareLabelProduct(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_ALL_CARELABEL,
        payload: res.data ? res.data : [],
      });
      return true;
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const fetchCareInstructionProduct = (params) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getCareInstructionProduct(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_ALL_CARE_INSTRUCTION,
        payload: res.data ? res.data : [],
      });
      return res?.data;
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const saveMarkCompleted = (params, val, transactionMsg) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.saveMarkCompleted(params, val);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_MARKED'), 'success');
      await dispatch({
        type: type.UPDATE_CARE_LABEL_MARK_COMPLETE,
        payload: val,
      });
    }
    if (res && res.code === 400) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
      await dispatch({
        type: type.UPDATE_CARE_LABEL_MARK_COMPLETE,
        payload: !val,
      });
    }
    return res;
  } catch (error) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const fetchCareLabelLibrary = (params) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getCareLabelLibraryList(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_CARELABEL_LIBRARY,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const fetchCareLabelGroup = (params) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getCareLabeGroupList(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_CARELABEL_GROUP,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

// eslint-disable-next-line consistent-return
export const fetchCareLabelProductWise = (data) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getCareLabeProductList(data);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_CARELABEL_PRODUCT_lIST,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

// eslint-disable-next-line consistent-return
export const fetchCareLabelProductAsyncData = (data) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getLabelProductAsyncData(data);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_CARE_LABEL_PRODUCT_DATA,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

// eslint-disable-next-line consistent-return, sonarjs/no-identical-functions
export const AddCareLabelLibraryData = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.addCareLabelLibrary(data);
    if (res && res.code === 200 && res.data) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_ADDED'), 'success');
      return res;
    }
    toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.LIBRARY_EXIST'), 'danger');
    return res;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const AddCareLabelGroupData = (data, t) => async () => {
  try {
    const res = await CareLabelConfigService.addCareLabelGroup(data);
    if (res && res.code === 200) {
      toasterMsg(t('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_GROUP_ADDED'), 'success');
      return res;
    }
    toasterMsg(t(res?.data?.errMsg), 'danger');
    return res;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const AddCareLabelProductData = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.addCareLabelProduct(data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_ADDED_SUCCESSFULY'), 'success');
      return res;
    }
    toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_EXIST_SUCCESSFULY'), 'danger');
    return res;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const DeleteCareLabelProduct = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.deleteCareLabel(data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_DELETED_SUCCESSFULY'), 'success');
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const MultiDeleteCareLabel = (devOrderId, data) => async () => {
  try {
    const res = await CareLabelConfigService.deleteMultipleCareLabel(devOrderId, data);
    if (res?.code === 200) {
      toasterMsg('Care label libraries of product deleted successfully.', 'success');
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const AddCareLabel = (devOrderId, data, transactionMsg) => async () => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
      return formData;
    });
    const res = await CareLabelConfigService.addCareLabel(devOrderId, formData);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_ADDED'), 'success');
      return res;
    }
    const msg = transactionMsg(`CARE_LABEL.${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const EditCareLabel = (devOrderId, id, data, transactionMsg) => async () => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    const res = await CareLabelConfigService.editCareLabel(devOrderId, id, formData);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_UPDATED'), 'success');
      return res;
    }
    const msg = transactionMsg(`CARE_LABEL.${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
    return res;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const addProductIntoLibrary = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.addProductIntoLibrary(data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_SUCCESSFULY'), 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const message = `CARE_LABEL.${res.data.errMsg}`;
      const msg = transactionMsg(message);
      toasterMsg(msg, 'danger');
    }

    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const fetchCareLabelLayout = (devOrderId) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.fetchLayoutData(devOrderId);

    if (res?.code === 200) {
      await dispatch({
        type: type.GET_CARE_LAYOUT_DATA,
        payload: res?.data ? res.data.doc : [],
      });
      return true;
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const approveRejectLayout = (devOrderId, payload, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.approveRejectData(devOrderId, payload);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.COMMENT_ADDED_SUCCESSFULY'), 'success');
      return true;
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const deleteLayoutPdf = (devOrderId, id, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.deleteCarePdf(devOrderId, id);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.ORDER_REPORT_SUCCESSFULY'), 'success');
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const uploadPDFforCareLayout = (devOrderId, data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.uploadPDFforCareLayout(devOrderId, data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_UPDATED_SUCCESSFULY'), 'success');
      return res;
    }
    toasterMsg(transactionMsg(data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const deleteCareComments = (devOrderId, data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.deletePdfComments(devOrderId, data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.COMMENT_DELETED_SUCCESSFULY'), 'success');
      return res;
    }
    toasterMsg(transactionMsg(data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const saveCareSequence = (devOrderId, data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.saveCareProductSequence(devOrderId, data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_SEQUENCE_SUCCESSFULY'), 'success');
      return true;
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const clearCareLabelReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: type.CLEAR_CARE_LABEL_REDUCER,
    });
  } catch (err) {
    console.log('............', err);
  }
};

export const addCareUserInstruction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.addCareUserInstruction(data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_ADDED'), 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const deleteCareInstruction = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.deleteCareInstruction(data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_DELETED_SUCCESSFULY'), 'success');
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const rearrangeCareLabel = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelConfigService.rearrangeCareLabel(data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_SEQUENCE_SUCCESSFULY'), 'success');
      return true;
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const getProductCareGroup = (devOrderId) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getProductCareGroup(devOrderId);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_ALL_CARE_GROUP,
        payload: res.data ? res.data : [],
      });
      return true;
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

// eslint-disable-next-line consistent-return
export const fetchCareProduct = (data) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.fetchCareProduct(data);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_PRODUCT_LIST,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const fetchCareLibraries = (data) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.fetchCareLibraries(data);
    console.log('ressss', res);
    if (res?.code === 200) {
      await dispatch({
        type: type.GET_CARE_LIBRARIES_DATA,
        payload: res?.data ? res.data : {},
      });
      return res.data;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const fetchProductCareData = (data) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.fetchProductCareData(data);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: type.GET_PRODUCT_LIST,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const importCareLabel = (data, translationMsg) => async () => {
  try {
    const res = await CareLabelConfigService.importCareLabel(data);
    if (res?.code === 200) {
      toasterMsg(translationMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_ADDED'), 'success');
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const importCareGroup = (data, translationMsg) => async () => {
  try {
    const res = await CareLabelConfigService.importCareGroup(data);
    if (res?.code === 200) {
      toasterMsg(translationMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_ADDED'), 'success');
      return res;
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const addToLibrary = (devOrderId, data, translationMsg) => async () => {
  try {
    const res = await CareLabelConfigService.addToLibrary(devOrderId, data);
    if (res?.code === 200) {
      toasterMsg(translationMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_CARE_LABEL_CONTROLLER.CARE_LABEL_SUCCESSFULY'), 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const message = `CARE_LABEL.${res.data.errMsg}`;
      const msg = translationMsg(message);
      toasterMsg(msg, 'danger');
    }
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};

export const refreshTabs = (id, transactionMsg) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.refreshTabs(id);
    if (res?.code === 200) {
      await dispatch({
        type: type.GET_PRODUCT_USER_INSTRUCTION_DETAILS,
        payload: res?.data,
      });
      toasterMsg(transactionMsg('modules/care-user-instructions:TABS_REFRESH_SUCCESSFULLY'), 'success');
      return true;
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCareLabelForProductDpp = (params) => async (dispatch) => {
  try {
    const res = await CareLabelConfigService.getCareInstructionProduct(params);
    if (res?.code === 200 && res.data) {
      return res?.data?.tabs || [];
    }
    return [];
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};
